import React, { useState, useEffect, useContext } from "react";
import axios from "axios";

import closeIcon from "../../images/close.png";

import { DEMO_FORM } from "../../modules/constants";
import Button from "../Button";
import { sanitizeHtml } from "../../utils/sanitizeHtml";
import TextInput from "../TextInput";
import BlunoSlider from "../BlunoSlider";
import { DeviceContext } from "../../context/DeviceContext";
import MultiselectDropdown from "../MultiselectDropdown";
import CloseIcon from "../../images/svg/CloseIcon";
import IndiaIcon from "../../images/svg/IndiaIcon";
import { UnoButton, UnoInput } from "@blunopay/bluno-react-library";
import { DEMO_FORM_SLUGS } from "../../utils/constants/demoFormConstants";
import {
  validateEMAIL,
  validateName,
  validatePhoneNumber,
} from "../../utils/Validation";

const DemoClone = ({
  location,
  setScreen,
  setOpenModal,
  flowType = "home",
}) => {
  const data = DEMO_FORM;

  const params = new URLSearchParams(location?.search);
  const referralParameter = params.get("referral");

  const { isMobileDevice, isTabletDevice, width } = useContext(DeviceContext);

  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState({});
  const [currency, setCurrency] = useState("inr");
  const [submitError, setSubmitError] = useState("");

  const getValueText = (value) => {
    if (currency === "inr") {
      if (Math.round(value) != value) value = value.toFixed(2);

      if (value !== 1 && value !== 500) return `${value} Cr`;
      else if (value === 1) return `<${value} Cr`;
      else return `>${value} Cr`;
    } else {
      if (value === 100) {
        return `<${value}K`;
      }
      if (value === 50000) {
        return `>${value / 1000}M`;
      }
      if (value < 1000) {
        return `${value}K`;
      } else {
        return `${value / 1000}M`;
      }
    }
  };
  const calculateScale = (value) => {
    if (currency === "inr") {
      if (value >= 0 && value < 100) {
        return 1 + (value * 4) / 100;
      } else if (value >= 100 && value < 200) {
        return 5 + ((value - 100) * 20) / 100;
      } else if (value >= 200 && value < 300) {
        return 25 + ((value - 200) * 25) / 100;
      } else if (value >= 300 && value < 400) {
        return 50 + ((value - 300) * 50) / 100;
      } else if (value >= 400 && value <= 500) {
        return 100 + ((value - 400) * 400) / 100;
      }
    } else {
      if (value >= 0 && value < 100) {
        return 100 + (value * 400) / 100;
      } else if (value >= 100 && value < 200) {
        return 500 + ((value - 100) * 500) / 100;
      } else if (value >= 200 && value < 300) {
        return 1000 + ((value - 200) * 4000) / 100;
      } else if (value >= 300 && value < 400) {
        return 5000 + ((value - 300) * 20000) / 100;
      } else if (value >= 400 && value <= 500) {
        return 25000 + ((value - 400) * 25000) / 100;
      }
    }
  };
  const getMarks = (marks) => {
    return marks.map((item, idx) => {
      return {
        value: item?.value,
        label: (
          <div
            style={{
              textAlign:
                idx === 0
                  ? "left"
                  : idx === marks.length - 1
                  ? "right"
                  : "center",
              width: idx === marks.length - 1 ? "54px" : "",
              marginLeft:
                idx === marks.length - 1 ? "-50px" : idx === 0 ? "34px" : "",
            }}
          >
            {item?.text1}
            <br />
            {item?.text2}
          </div>
        ),
      };
    });
  };

  const handleInputChange = (slug, value, sub_type, e) => {
    if (sub_type === "tel") {
      // Only allow digits, max 10
      const sanitizedValue = value.replace(/\D/g, "").slice(0, 10);
      setFormValues({ ...formValues, [slug]: sanitizedValue });
      if (sanitizedValue.length < value.length) {
        setErrors({ ...errors, [slug]: "Only digits allowed, max 10 digits" });
      } else {
        setErrors({ ...errors, [slug]: null });
      }
    } else if (slug === DEMO_FORM_SLUGS.client_name) {
      const sanitizedValue = value.replace(/[^A-Za-z\s]/g, "");
      setFormValues({ ...formValues, [slug]: sanitizedValue });
      if (sanitizedValue.length < value.length) {
        setErrors({ ...errors, [slug]: "Only letters and spaces are allowed" });
      } else {
        setErrors({ ...errors, [slug]: null });
      }
    } else {
      setFormValues({ ...formValues, [slug]: value });
      setErrors({ ...errors, [slug]: null });
    }
  };

  const handleOnFocusOut = (slug, value, sub_type, e) => {
    if (slug === DEMO_FORM_SLUGS?.client_name && value.trim() !== "") {
      const isValidName = validateName(value);
      if (!isValidName) {
        setErrors({ ...errors, [slug]: "Only letters and spaces are allowed" });
        return;
      }
    }
    if (sub_type === "email" && value.trim() !== "") {
      // Email validation
      const isValidEmail = validateEMAIL(value.trim());
      if (!isValidEmail) {
        setErrors({ ...errors, [slug]: "Enter a valid email address" });
      } else {
        setErrors({ ...errors, [slug]: null });
      }
    } else if (sub_type === "tel" && value.trim() !== "") {
      // Phone number validation
      const isValidPhoneNumber = validatePhoneNumber(value);
      if (!isValidPhoneNumber) {
        if (value.toString().length > 10)
          setErrors({
            ...errors,
            [slug]: "You have entered 10 digits",
          });
        else
          setErrors({
            ...errors,
            [slug]: "Enter correct mobile number",
          });
      } else {
        setErrors({ ...errors, [slug]: null });
      }
    }
  };

  const handleSelectChange = (
    selectedOption,
    slug,
    isMultipleSelect = false
  ) => {
    if (isMultipleSelect) {
      setFormValues({
        ...formValues,
        [slug]: selectedOption,
      });
    } else {
      // setCurrency(selectedOption.value);
      setFormValues({ ...formValues, [slug]: selectedOption.value });
    }
  };

  const handleCheckBoxClick = (parentSlug, childSlug, theValue) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [parentSlug]: {
        ...prevFormValues[parentSlug],
        [childSlug]: theValue,
      },
    }));
  };

  function convertClientType(slug) {
    const options = ["export", "import"];
    const result = {};

    options.forEach((opt) => {
      result[opt] = slug === "both" || slug === opt;
    });

    return result;
  }

  function handleSegmentedToggleChange(fieldSlug, selectedSlug) {
    const objValue = convertClientType(selectedSlug);
    // set formValues with the object, not the slug string
    setFormValues((prev) => ({
      ...prev,
      [fieldSlug]: objValue,
    }));
  }

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    data.form_data.forEach((item) => {
      const value = formValues[item?.slug];
      const showOtherBanksField =
        item?.slug === "other_banks" &&
        formValues?.company_banking_partners?.includes("others");

      if (showOtherBanksField && !value) {
        newErrors[item?.slug] = "This field is required";
        isValid = false;
      } else if (
        !value &&
        item?.type === "input" &&
        item?.slug !== "other_banks" &&
        item?.slug !== "referral_code"
      ) {
        const REQUIRED_MESSAGES = {
          [DEMO_FORM_SLUGS.client_name]: "Name is required",
          [DEMO_FORM_SLUGS.company_name]: "Company name is required",
          [DEMO_FORM_SLUGS.mobile_number]: "Mobile number is required",
          [DEMO_FORM_SLUGS.email_address]: "Email address is required",
        };

        data.form_data.forEach((item) => {
          const value = formValues[item?.slug];

          const showOtherBanksField =
            item?.slug === "other_banks" &&
            formValues?.company_banking_partners?.includes("others");

          if (
            (showOtherBanksField && !value) ||
            (!value && !showOtherBanksField)
          ) {
            newErrors[item.slug] =
              REQUIRED_MESSAGES[item.slug] || "This field is required";
          }
        });
        isValid = false;
      } else if (
        item?.type === "input" &&
        (item?.sub_type === "email" || item?.sub_type === "tel")
      ) {
        if (value) {
          if (item?.sub_type === "email") {
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
              value.trim()
            );
            if (!isValidEmail) {
              newErrors[item?.slug] = "Please enter a valid email address";
              isValid = false;
            }
          } else if (item?.sub_type === "tel") {
            const isValidPhoneNumber = /^\d{10}$/.test(value);
            if (!isValidPhoneNumber) {
              newErrors[item?.slug] = "Please enter a 10-digit phone number";
              isValid = false;
            }
          }
        }
      } else if (
        item?.type === "input" &&
        item?.slug === "referral_code" &&
        value
      ) {
        const isValidReferralCode = /^[A-Z]{4}[\d]{3}$/.test(value);
        if (!isValidReferralCode) {
          newErrors[item?.slug] = "Invalid referral code";
          isValid = false;
        }
      } else if (
        item?.type === "multi_select_dropdown" &&
        item?.isMultipleSelect
      ) {
        if (!value || value?.length === 0) {
          newErrors[item?.slug] = "Please select at least one option";
          isValid = false;
        } else if (value?.length > 3) {
          newErrors[item?.slug] = "You can select a maximum of three options";
          isValid = false;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmitForm = async () => {
    const tempFormValues = {
      ...formValues,
      // company_banking_partners: [
      //   ...formValues?.company_banking_partners,
      //   formValues?.other_banks,
      // ],
    };

    let tempFormFormattedValues = JSON.parse(JSON.stringify(tempFormValues));
    tempFormFormattedValues.email_address =
      tempFormFormattedValues.email_address.trim();
    const requestBody = {
      demo_type: "callback_request",
      form_data: tempFormFormattedValues,
      scheduling_data: null,
      flow: flowType,
    };

    //TODO: CHANGE URL FOR PROD
    await axios
      .post("https://demo.bluno.in/v1/bluno/book-demo", requestBody)
      .then((response) => {
        if (response?.data?.success) {
          setScreen(2);
        }
      })
      .catch((error) => {
        if (error?.response && error?.response?.data) {
          if (Object?.keys(error?.response?.data?.errors)?.length > 0) {
            setErrors(error?.response?.data?.errors);
          } else {
            setSubmitError(error?.response?.data?.message);
          }
        }
      });
  };

  const handleSubmit = () => {
    if (validateForm()) {
      handleSubmitForm();
    }
  };

  const handleCloseClick = () => {
    if (flowType === "home") {
      setOpenModal(false);
    } else {
      window.parent.postMessage("close", "*");
    }
  };

  const renderFormElement = (obj) => {
    const showOtherBanksField =
      obj?.slug === "other_banks" &&
      formValues?.company_banking_partners?.includes("others");

    switch (obj?.type) {
      case "input":
        return (
          <>
            {(obj?.slug !== "other_banks" || showOtherBanksField) && (
              <div
                style={{
                  gridColumn: `${obj?.column}`,
                  gridRow: `${obj?.row}`,
                  display: "flex",
                  flexDirection: "column",
                }}
                className={`s-demo__group-text-input ${
                  obj?.last === true ? "s-demo__input--last" : ""
                } `}
              >
                {obj?.label && (
                  <p
                    className="s-demo__label"
                    dangerouslySetInnerHTML={sanitizeHtml(obj?.label)}
                  ></p>
                )}
                {/* <TextInput
                  placeholder={obj?.placeholder}
                  value={formValues[obj?.slug]}
                  showMuiInput={true}
                  height="38px"
                  minWidth="225px"
                  iconAlignment="right"
                  onChange={(e) =>
                    handleInputChange(
                      obj?.slug,
                      e.target.value,
                      obj?.sub_type,
                      e
                    )
                  }
                  onBlur={(e) =>
                    handleOnFocusOut(
                      obj?.slug,
                      e.target.value,
                      obj?.sub_type,
                      e
                    )
                  }
                  disabled={obj?.slug === "referral_code" && referralParameter}
                  errorMessage={errors[obj?.slug]}
                  searchIcon={false}
                  fixedText={obj?.sub_type === "tel" ? "+91" : ""}
                /> */}
                <UnoInput
                  type={obj?.sub_type || "text"}
                  placeholder={obj?.placeholder}
                  value={formValues[obj?.slug]}
                  height="36px"
                  minWidth="250px"
                  variant="outlined"
                  disabled={obj?.slug === "referral_code" && referralParameter}
                  status={errors[obj?.slug] ? "error" : undefined}
                  errorMessage={errors[obj?.slug]}
                  prefix={
                    obj?.sub_type === "tel" ? (
                      <div
                        className="s-demo__mobile-prefix"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <IndiaIcon />
                        <span>+91</span>
                      </div>
                    ) : undefined
                  }
                  onChange={(e) => {
                    const value =
                      typeof e === "string" || typeof e === "number"
                        ? e
                        : e?.target?.value;
                    handleInputChange(obj?.slug, value, obj?.sub_type, e);
                  }}
                  onBlur={(e) => {
                    const value =
                      typeof e === "string" || typeof e === "number"
                        ? e
                        : e?.target?.value;
                    handleOnFocusOut(obj?.slug, value, obj?.sub_type, e);
                  }}
                  readOnly={obj?.readonly}
                  required={obj?.required}
                  maxLength={obj?.maxLength}
                  minLength={obj?.minLength}
                  name={obj?.slug}
                  inputMode={obj?.inputMode}
                  autoComplete={obj?.autoComplete}
                  autoFocus={obj?.autoFocus}
                  extraClass="s-demo__text-input"
                />
              </div>
            )}
          </>
        );
      case "checkbox":
        return (
          <div
            className="s-demo__group-checkbox"
            style={{
              gridRow: `${obj?.row}`,
              gridColumn: `${obj?.column}`,
              display: "grid",
            }}
          >
            <p
              className="s-demo__label"
              dangerouslySetInnerHTML={sanitizeHtml(obj?.label)}
            ></p>
            <div className="s-demo__radio-list">
              {obj?.options?.map((item, idx) => {
                return (
                  <div key={idx} className="s-demo__radio">
                    <input
                      type="checkbox"
                      name={item?.name}
                      id={`${item?.name}_${idx}`}
                      value={item?.slug}
                      onChange={(e) =>
                        handleCheckBoxClick(
                          obj?.slug,
                          item?.slug,
                          e.target.checked
                        )
                      }
                      key={item?.slug + idx}
                    />
                    <label htmlFor={`${item?.name}_${idx}`}>{item?.text}</label>
                  </div>
                );
              })}
            </div>
            {errors[obj?.slug] && (
              <p className="s-demo__error">{errors[obj?.slug]}</p>
            )}
          </div>
        );
      case "multi_select_dropdown":
        return (
          <div
            className="s-demo__group-dropdown"
            style={{
              gridRow: `${obj?.row}`,
              gridColumn: `${obj?.column}`,
              display: "grid",
            }}
          >
            <div className="s-demo__dropdown-title">
              <div className="s-demo__dropdown-cont">
                <MultiselectDropdown
                  options={obj?.options}
                  onSelectChange={(selectedOption) => {
                    handleSelectChange(
                      selectedOption,
                      obj?.slug,
                      obj?.isMultipleSelect
                    );
                  }}
                  defaultValue={formValues[obj?.slug]}
                  placeholder={obj?.placeholder}
                  fontSize="13px"
                  fontWeight="400"
                  valuePadding="0px"
                  indicatorPadding="0px"
                  minWidth="225px"
                  maxWidth="284px"
                  minHeight="38px"
                  isMultipleSelect={obj?.isMultipleSelect}
                  maxAllowedSelections={obj?.maxAllowedSelections}
                />
              </div>
            </div>
            {errors[obj?.slug] && (
              <p className="s-demo__error-dropdown">{errors[obj?.slug]}</p>
            )}
          </div>
        );
      case "slider":
        return (
          <div
            style={{
              gridRow: `${obj?.row}`,
              display: "grid",
              gridColumn: `${obj?.column}`,
            }}
            className="s-demo__slider"
          >
            <BlunoSlider
              step={obj?.step}
              min={obj?.min}
              max={obj?.max}
              marks={
                currency === "inr"
                  ? getMarks(obj?.marks)
                  : getMarks(obj?.marksUSD)
              }
              valueLabelDisplay={"auto"}
              scale={calculateScale}
              getAriaValueText={getValueText}
              valueLabelFormat={getValueText}
              onChange={(e) => {
                const value = getValueText(calculateScale(e.target.value));
                handleInputChange(obj?.slug, value, null, e);
              }}
            />
          </div>
        );
      case "button":
        return (
          <div className="s-demo__button">
            <UnoButton
              buttonLabel={obj?.button_label}
              fontSize="14px"
              onClick={() => {
                handleSubmit();
              }}
              width="280px"
              height="40px"
              extraClass="s-demo__request-demo"
            />
            {submitError && <p className="s-demo__error">{submitError}</p>}
          </div>
        );
      case "text":
        return (
          <div
            style={{
              gridColumn: `${obj?.column}`,
              gridRow: `${obj?.row}`,
              display: "flex",
            }}
            className="s-demo__group-text"
          >
            <p
              dangerouslySetInnerHTML={sanitizeHtml(obj?.text, {
                ADD_ATTR: ["target"],
              })}
              className="s-demo__agreement"
            ></p>
          </div>
        );
      case "segmented_toggle":
        const activeObj = formValues[obj.slug] || {};
        return (
          <div
            className="s-demo__segmented-toggle"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <p
              className="s-demo__segmented-toggle-label"
              dangerouslySetInnerHTML={sanitizeHtml(obj?.label)}
            ></p>
            <div className="s-demo__segmented-toggle__options">
              {obj?.options?.map((option, index) => {
                const isMiddle = index === 1 && obj.options.length === 3;
                const isActive =
                  (option.slug === "both" &&
                    activeObj.export &&
                    activeObj.import) ||
                  (option.slug === "export" &&
                    activeObj.export &&
                    !activeObj.import) ||
                  (option.slug === "import" &&
                    !activeObj.export &&
                    activeObj.import);

                return (
                  <button
                    key={option.slug}
                    className={`s-demo__segmented-toggle__button ${
                      isActive ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleSegmentedToggleChange(obj.slug, option.slug);
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault(); // Prevent focus
                    }}
                    type="button"
                  >
                    {option.text}
                  </button>
                );
              })}
            </div>
            {errors[obj?.slug] && (
              <p className="s-demo__error">{errors[obj?.slug]}</p>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    const initialFormValues = {
      export_turnover_currency: "inr",
      client_type: {
        export: false,
        import: false,
      },
      referral_code: referralParameter,
    };

    setFormValues(initialFormValues);

    Array.from(document?.getElementsByClassName("MuiSlider-markLabel"))?.map(
      (item, idx) => {
        if (item?.style?.left === "0.4%") {
          item.style.marginLeft = "-10px";
        }
        if (item?.style?.left === "98.6%") {
          item.style.marginLeft = "10px";
        }
      }
    );
  }, []);

  return (
    <div className="s-demo">
      <div className="s-demo__left">
        <img
          className="s-demo__banner"
          src="https://static.bluno.in/landing/demo-form-image.webp"
          alt="Book a demo"
        />
      </div>
      <div className="s-demo__right-modal">
        <div className="s-demo__right">
          {!isMobileDevice && (
            <div className="s-demo__right-top">
              <img
                className="s-demo__right-heading-logo"
                src="https://static.bluno.in/bold_bluno_logo.png"
                alt="heading-logo"
              />
              <div onClick={handleCloseClick} className="s-demo__close">
                <CloseIcon color="#8998AD" />
              </div>
            </div>
          )}
          <div className="s-demo__form-cont">
            <div className="s-demo__title-container">
              <div className="s-demo__wrapper">
                <h1
                  className="s-demo__title"
                  dangerouslySetInnerHTML={{ __html: data?.title }}
                />
                {isMobileDevice && (
                  <div onClick={handleCloseClick} className="s-demo__close">
                    <CloseIcon color="#8998AD" />
                  </div>
                )}
              </div>
              <p
                className="s-demo__subtitle"
                dangerouslySetInnerHTML={{ __html: data?.sub_title }}
              />
            </div>
            <div className="s-demo__form">
              {data?.form_data
                ?.filter(
                  (obj) =>
                    !["client_type", "agreement", "request_demo"].includes(
                      obj.slug
                    )
                )
                .map((obj, idx) => renderFormElement(obj))}
              <div className="s-demo__client-business-type">
                {data?.form_data
                  ?.filter((obj) => obj.slug === "client_type")
                  .map((obj, idx) => renderFormElement(obj))}
              </div>
            </div>
            <div className="s-demo__agreement">
              {data?.form_data
                ?.filter((obj) => obj.slug === "agreement")
                .map((obj, idx) => renderFormElement(obj))}
            </div>
            <div className="s-demo__button">
              {data?.form_data
                ?.filter((obj) => obj.slug === "request_demo")
                .map((obj, idx) => renderFormElement(obj))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoClone;
